/**
 * Luminous Made — Custom Media Gallery v3
 * Scroll-snap slider with natural drag (Dawn-like),
 * arrows, counter, and robust video play/pause logic.
 */



// === Luminous Made — Shared gallery state (desktop <-> mobile) ===
window.__lmGalleryState = {
  index: 0,
  paused: false,            // ✅ NEW: shared play/pause state
  settingFrom: null // 'mobile' or 'desktop' to avoid loops
};

// Expose a safe sync setter used by both galleries
window.lmGallerySync = function setSharedIndex(nextIndex, source) {
  // Guard: coerce and reject NaN / non-finite values
  nextIndex = Number(nextIndex);
  if (!Number.isFinite(nextIndex)) return;

  const s = window.__lmGalleryState;
  if (typeof nextIndex !== 'number') return;

  // prevent feedback loops
  if (s.settingFrom && s.settingFrom !== source) return;

  s.index = nextIndex;
  s.settingFrom = source;

    // Update Desktop stage (safe: only toggle if target exists; else retry)
  try {
    const stage = document.querySelector('[data-d-stage]');
    if (stage) {
      const slides = stage.querySelectorAll('.lm-d-slide');
      const target = stage.querySelector(`.lm-d-slide[data-d-index="${nextIndex}"]`);

      if (!target) {
        // Desktop not fully rendered yet — try again shortly without clearing current state
        setTimeout(() => window.lmGallerySync?.(nextIndex, source), 60);
      } else {
        // We have a real target; now it's safe to toggle
        slides.forEach((el) => el.classList.remove('is-active'));
        target.classList.add('is-active');

        // toggle desktop thumb active
        const dThumbs = document.querySelectorAll('[data-d-thumb-index]');
        dThumbs.forEach(b => b.classList.toggle('is-active', Number(b.dataset.dThumbIndex) === nextIndex));

        // --- Desktop video control using shared state ---
        const allVideos = stage.querySelectorAll("video");
        allVideos.forEach((v) => v.pause());

        const activeVideo = target.querySelector("video");
        const s = window.__lmGalleryState || {};
        const shouldBePaused = !!s.paused; // ✅ global truth

        if (activeVideo) {
          activeVideo.dataset.userPaused = shouldBePaused ? 'true' : 'false';

          if (!shouldBePaused) {
            activeVideo.play().catch(() => {});
          }

          // ✅ Keep desktop button + desktop thumb icon in sync immediately
          const desktopBtn = target.querySelector("[data-d-video-toggle]");
          const thumbIcon = document.querySelector(
            `.lm-d-thumb[data-d-thumb-index="${nextIndex}"] .lm-thumb-icon svg path`
          );

          const setIcons = (playing) => {
            if (desktopBtn) {
              desktopBtn.innerHTML = playing
                ? `<svg viewBox="0 0 24 24"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>`
                : `<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>`;
            }
            if (thumbIcon) {
              thumbIcon.setAttribute(
                "d",
                playing
                  ? "M6 5h4v14H6zm8 0h4v14h-4z" // pause
                  : "M8 5v14l11-7z"             // play
              );
            }
          };

          setIcons(!shouldBePaused);
          activeVideo.addEventListener("play", () => setIcons(true));
          activeVideo.addEventListener("pause", () => setIcons(false));
        }
      }
    }
  } catch (_) {}


  // Update Mobile gallery by jumping instantly (no fly-through)
  try {
    if (typeof window.__lmJumpTo === 'function' && source !== 'mobile') {
      window.__lmJumpTo(nextIndex);
    }
  } catch (_) {}

  // clear setter flag in next tick
  setTimeout(() => { s.settingFrom = null; }, 0);

  // === Single source-of-truth setter (tiny facade) ===
  window.lmSetIndex = function lmSetIndex(idx, source) {
  window.lmGallerySync?.(idx, source || 'controller');
  };

  // === Shared paused setter (keeps both galleries in sync) ===
  window.lmSetPaused = function lmSetPaused(paused, source) {
    const s = window.__lmGalleryState || (window.__lmGalleryState = { index: 0, paused: false, settingFrom: null });
    if (s.settingFrom && s.settingFrom !== source) return;
    s.paused = !!paused;
    s.settingFrom = source;

    const idx = Number.isFinite(s.index) ? s.index : 0;

    // ACTIVE desktop slide
    try {
      const dSlide = document.querySelector(`.lm-d-slide.is-active[data-d-index="${idx}"]`) ||
                    document.querySelector(`.lm-d-slide[data-d-index="${idx}"]`);
      const dVideo = dSlide?.querySelector('video');
      if (dVideo) {
        dVideo.dataset.userPaused = paused ? 'true' : 'false';
        if (paused) { dVideo.pause(); } else { dVideo.play().catch(() => {}); }
      }
    } catch {}

    // ACTIVE mobile slide
    try {
      const mSlide = document.querySelector(`.lm-slide[data-index="${idx}"]`);
      const mVideo = mSlide?.querySelector('video');
      if (mVideo) {
        mVideo.dataset.userPaused = paused ? 'true' : 'false';
        if (paused) { mVideo.pause(); } else { mVideo.play().catch(() => {}); }
      }
    } catch {}

    // release lock next tick
    setTimeout(() => { s.settingFrom = null; }, 0);
  };


};



function initLmGallery() {
  // --- Prevent rapid duplicate inits (Shopify section reload guard)
  if (window.__lmGalleryInitializing) return;
  window.__lmGalleryInitializing = true;
  setTimeout(() => (window.__lmGalleryInitializing = false), 300);
  
  // Find your custom gallery in the DOM
  const gallery = document.querySelector("[data-gallery]");
  if (!gallery) return; // no gallery present at all

  // --- Enable unified gallery (desktop + mobile)
  const isMobile = window.matchMedia("(max-width: 749px)").matches;
  const isDesktop = window.matchMedia("(min-width: 750px)").matches;

  // You can still selectively modify behavior per viewport
  let enableSwipe = isMobile; // allow drag-swipe only on mobile

  // (we no longer "return" early for desktop)


  // Force-load video metadata to prevent grey placeholder
  const videos = gallery.querySelectorAll(".lm-video");
  videos.forEach((video) => {
    try {
      video.load(); // ensures first frame ready
    } catch (e) {
      console.warn("Video preload skipped", e);
    }
  });

  const track = gallery.querySelector("[data-gallery-track]");
  // Enable/disable scroll snap during layout transitions
  const enableSnap = () => (track.style.scrollSnapType = "");
  const disableSnap = () => (track.style.scrollSnapType = "none");
  const slides = Array.from(track?.children || []);
  const prevBtn = gallery.querySelector(".lm-prev");
  const nextBtn = gallery.querySelector(".lm-next");
  const counterCurrent = gallery.querySelector(".lm-current");
  const counterTotal = gallery.querySelector(".lm-total");
  // --- Thumbnails (updated structure)
  const thumbsWrapper = gallery.querySelector("[data-thumbs-wrapper]");
  const thumbsViewport = thumbsWrapper?.querySelector(".lm-thumbs-viewport");
  const thumbsTrack = thumbsWrapper?.querySelector("[data-thumbs-track]");
  const thumbs = thumbsTrack
    ? Array.from(thumbsTrack.querySelectorAll(".lm-thumb"))
    : [];

  const thumbPrev = gallery.querySelector("[data-thumb-prev]");
  const thumbNext = gallery.querySelector("[data-thumb-next]");


  // Briefly pause scroll-based sync during viewport breakpoint changes
  let resizeLock = false;
  let breakpointLock = false;


  if (!track || !slides.length) return;

  // --- Setup
  let currentIndex = 0;
  let pendingIndex = null;
  const total = slides.length;
  if (counterTotal) counterTotal.textContent = total;

  // Ensure each slide snaps at 100% width even on resize
  const setSlideWidths = () => {
    const w = track.clientWidth; // width of the visible viewport
    slides.forEach((s) => (s.style.minWidth = w + "px"));
  };
  setSlideWidths();


  // --- Helpers
  const slideWidth = () => track.clientWidth;
  const toIndex = (idx) => Math.max(0, Math.min(total - 1, idx));
  const scrollToIndex = (idx, smooth = true) => {
    currentIndex = toIndex(idx);
    track.scrollTo({
      left: currentIndex * slideWidth(),
      behavior: smooth ? "smooth" : "auto",
    });
    updateCounter();
    updateThumbActiveState(currentIndex);
    updateArrowDisabledState();
  };
  // --- Luminous Made: request a one-time restart for a video slide when it becomes active
  const requestVideoRestart = (idx) => {
    const slide = slides[idx];
    const video = slide?.querySelector("video");
    if (!video) return;
    video.dataset.lmRestart = "true"; // consumed by IO when the slide becomes active
  };



  const jumpToIndex = (idx) => {
    currentIndex = toIndex(idx);
    track.style.scrollBehavior = "auto"; // temporarily kill smooth scrolling
    track.scrollTo({
      left: currentIndex * slideWidth(),
      behavior: "auto",
    });
    // force re-enable smooth for normal swipes/arrows after this tick
    requestAnimationFrame(() => {
      track.style.scrollBehavior = "";
    });

    updateCounter();
    updateThumbActiveState(currentIndex);
    updateArrowDisabledState();
  };


    // Recompute slide widths then jump (used during viewport changes)
    window.__lmRecomputeAndJump = (idx) => {
      // Re-measure viewport & enforce slide width
      setSlideWidths();
      // Jump after the DOM has applied the new widths
      requestAnimationFrame(() => jumpToIndex(idx));
    };


  const updateCounter = () => {
    if (counterCurrent) counterCurrent.textContent = currentIndex + 1;

    // Disable/enable arrows at boundaries (like Dawn)
    if (prevBtn && nextBtn) {
      prevBtn.disabled = currentIndex === 0;
      nextBtn.disabled = currentIndex === total - 1;
    }
  };

  // Highlight the active thumb
  const updateThumbActiveState = (activeIdx) => {
    // Block thumbnail updates during arrow-driven swipe animation
    if (pendingIndex !== null) return;

    thumbs.forEach((btn) => btn.classList.remove("is-active"));
    const activeThumb = thumbs.find(
      (btn) => Number(btn.dataset.thumbIndex) === activeIdx
    );
    if (activeThumb) {
      activeThumb.classList.add("is-active");

      // optional: keep the active thumb in view
      const twRect = thumbsViewport.getBoundingClientRect();
      const thRect = activeThumb.getBoundingClientRect();

      const overflowLeft = thRect.left < twRect.left + 16;
      const overflowRight = thRect.right > twRect.right - 16;

      if (overflowLeft || overflowRight) {
        thumbsViewport.scrollTo({
          left:
            activeThumb.offsetLeft -
            thumbsViewport.clientWidth / 2 +
            activeThumb.clientWidth / 2,
          behavior: "smooth",
        });
      }
    }
  };



  // When navigating via arrows, clear manual-pause and ensure overlay hides
  const navTo = (idx) => {
    const target = toIndex(idx);

    requestVideoRestart(target); // request video restart after computing target

    // prevent scroll listener from interfering until snap is done
    pendingIndex = target;

    const targetSlide = slides[target];
    const vid = targetSlide?.querySelector("video");
    if (vid) {
      vid.dataset.userPaused = "false";
      const ov = targetSlide.querySelector("[data-play-overlay]");
      ov && ov.classList.add("hidden");
    }

    scrollToIndex(target);
    window.lmSetIndex?.(target, "mobile");
  };




  // --- Arrow buttons
  prevBtn?.addEventListener("click", () => navTo(currentIndex - 1));
  nextBtn?.addEventListener("click", () => navTo(currentIndex + 1));


  // --- Thumbnail click navigation
  thumbs.forEach((thumbBtn) => {
    thumbBtn.addEventListener("click", () => {
      const idx = Number.parseInt(thumbBtn.dataset.thumbIndex, 10);
      if (!Number.isFinite(idx)) return;

      requestVideoRestart(idx); // restart request for 360 videos when clicking thumbnails

      // clear "userPaused" so autoplay logic works like arrow nav
      const targetSlide = slides[idx];
      const vid = targetSlide?.querySelector("video");
      if (vid) {
        vid.dataset.userPaused = "false";
        const ov = targetSlide.querySelector("[data-play-overlay]");
        ov && ov.classList.add("hidden");
      }

      // If navigating to a different slide, Hybrid C: unpause globally so new slide plays
      const s = window.__lmGalleryState || {};
      if (idx !== s.index) {
        window.lmSetPaused?.(false, 'mobile');   // ✅ force play for different slide
      }

      // instant jump, no fly-through
      jumpToIndex(idx);

      // keep desktop in sync
      window.lmGallerySync?.(idx, 'mobile');


      // --- Add subtle fade-in on thumbnail click ---
      const fadeTarget = slides[idx];
      fadeTarget.classList.add("fade-in");
      setTimeout(() => fadeTarget.classList.remove("fade-in"), 350); // match CSS timing

    });
  });



  // --- Thumbnail slider arrows ---
  const scrollAmount = 120; // adjust how far each click scrolls
  // --- Thumbnail arrows now control the main gallery ---
  thumbPrev?.addEventListener("click", () => navTo(currentIndex - 1));
  thumbNext?.addEventListener("click", () => navTo(currentIndex + 1));


  
  // --- Unified resize handler: drift-proof, width-safe, snap-safe ---
  window.addEventListener("resize", () => {
    const wasMobile = window.__lmWasMobile ?? (window.innerWidth <= 749);
    const nowMobile = window.innerWidth <= 749;

    // 1) Capture current slide index before layout shift
    const state = window.__lmGalleryState || {};
    const idx = Number.isFinite(state.index) ? state.index : currentIndex || 0;

    // 2) Freeze scrolling + snapping immediately
    resizeLock = true;
    breakpointLock = true;
    const prevSnap = track.style.scrollSnapType;
    track.style.scrollSnapType = "none";   // stop browser snap-corrections now
    const prevScrollBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = "auto";   // prevent scroll animation effects

    // 3) Recompute slide widths safely
    try { setSlideWidths?.(); } catch {}

    // 4) Re-align scroller to the SAME index using the NEW width
    try {
      const w = track.clientWidth;
      track.scrollLeft = idx * w;
    } catch {}

    // 5) Save mode for next tick
    window.__lmWasMobile = nowMobile;

    // 6) Restore behavior after layout settles
    setTimeout(() => {
      resizeLock = false;
      breakpointLock = false;
      track.style.removeProperty("scroll-snap-type");
      track.style.scrollBehavior = prevScrollBehavior || "";
    }, 150);
  });




  // --- Disable thumbnail arrows at first / last slide ---
  const updateArrowDisabledState = () => {
    if (!thumbPrev || !thumbNext) return;
    thumbPrev.disabled = currentIndex <= 0;
    thumbNext.disabled = currentIndex >= total - 1;
  };


  // --- Scroll listener: fast index commit, no flicker, no rollback ---
  let lastScrollLeft = 0;
  track.addEventListener(
    "scroll",
    () => {
      if (resizeLock || breakpointLock) return;

      const w = slideWidth();
      const raw = track.scrollLeft / w;

      // Detect direction & commitment:
      const committedIndex = Math.round(raw);
      const delta = Math.abs(raw - committedIndex);

      // Once we've passed ~30% toward the next snap target,
      // consider it locked and update immediately.
      if (delta < 0.30) { // Adjust to update thumbnails quicker or slower, this updates thumbnail when image moves 30 percent of it's width, lower number increases risk of misfire
        if (committedIndex !== currentIndex) {
          currentIndex = toIndex(committedIndex);

          // ✅ Unlock pending state so thumbnails can update again
          pendingIndex = null;

          updateCounter();
          updateArrowDisabledState?.();
          window.lmSetIndex?.(currentIndex, "mobile");
          updateThumbActiveState(currentIndex);
        }
      }

      lastScrollLeft = track.scrollLeft;
    },
    { passive: true }
  );









  // --- Video autoplay/pause based on visibility (IO = accurate + efficient)
  const allVideos = () => Array.from(gallery.querySelectorAll("video"));
  const pauseOthers = (keep) => {
    allVideos().forEach((v) => {
      if (v !== keep) {
        v.pause();
        const ov = v
          .closest(".lm-video-container")
          ?.querySelector("[data-play-overlay]");
        ov && ov.classList.remove("hidden");
      }
    });
  };

  // --- Pre-seek videos as they approach view (reduces visible snap on swipe) ---
  const preSeekIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        const slide = entry.target;
        const video = slide.querySelector("video");
        if (!video) return;

        // Don’t fight a user-paused video
        const userPaused = video.dataset.userPaused === "true";
        if (userPaused) return;

        // Pre-seek only once per activation pass
        if (video.dataset.lmPreSeeked === "true") return;

        try {
          video.pause();
          video.classList.add("is-resetting");
          if (video.currentTime > 0.05) video.currentTime = 0;
          video.dataset.lmPreSeeked = "true";

          // remove fade quickly (by the time it’s fully visible)
          const clear = () => video.classList.remove("is-resetting");
          video.addEventListener("seeked", clear, { once: true });
          // fallback in case seeked doesn’t fire
          setTimeout(clear, 80);
        } catch (_) {}
      });
    },
    // Lower threshold = triggers earlier while slide is still moving into view
    { root: null, threshold: 0.15 }
  );


  const io = new IntersectionObserver(
    (entries) => {

      entries.forEach((entry) => {
        const slide = entry.target;
        const video = slide.querySelector("video");
        if (!video) return;

        const overlay = slide.querySelector("[data-play-overlay]");
        const userPaused = video.dataset.userPaused === "true";

        // --- Activation edge detection (fixes swipe inconsistency) ---
        const wasActive = slide.dataset.lmWasActive === "true";
        const isActiveNow = entry.isIntersecting;

        if (isActiveNow && !wasActive) {
          // This slide just became active (swipe/scroll into view)
          slide.dataset.lmWasActive = "true";

          // Restart behavior:
          // - Always restart on activation (shows best-facing frame)
          // - But do it while paused to reduce visible jump
          if (!userPaused) {
            try {
              video.pause();
              // Only seek if we're not already near the start
              if (video.currentTime > 0.05) {
                video.currentTime = 0;
              }
            } catch (_) {}

            // Wait for the seek to settle before playing (reduces “jump”)
            const playAfterSeek = () => {
              video.removeEventListener("seeked", playAfterSeek);
              pauseOthers(video);
              const p = video.play();
              if (p && p.catch) p.catch(() => {});
              overlay && overlay.classList.add("hidden");
            };

            // If seeking actually occurs, rely on 'seeked'. Otherwise play next frame.
            try {
              video.addEventListener("seeked", playAfterSeek, { once: true });
              requestAnimationFrame(() => playAfterSeek());
            } catch (_) {
              pauseOthers(video);
              video.play().catch(() => {});
              overlay && overlay.classList.add("hidden");
            }
          }
          return;
        }

        if (isActiveNow) {
          // Still active; do NOT restart (prevents re-trigger while staying on slide)
          if (!userPaused) {
            pauseOthers(video);
            video.play().catch(() => {});
            overlay && overlay.classList.add("hidden");
          }
        } else {
          // No longer active
          slide.dataset.lmWasActive = "false";

          // ✅ IMPORTANT: allow pre-seek to run again next time this slide comes into view
          video.dataset.lmPreSeeked = "false";

          video.pause();
          if (!userPaused) overlay && overlay.classList.remove("hidden");
        }
      });

    },
    { root: null, threshold: 0.6 }
  );


  // === Counter observer (does NOT touch videos) ===
  const counterIO = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Skip index/thumbnail updates while a programmatic move is in progress
        if (pendingIndex !== null || resizeLock || breakpointLock) return;

        if (entry.isIntersecting) {
          const index = slides.indexOf(entry.target);
          if (index !== currentIndex) {
            currentIndex = index;
            updateCounter();
            updateThumbActiveState(currentIndex);
            updateArrowDisabledState?.();
            window.lmSetIndex?.(currentIndex, 'mobile');
          }
        }
      });
    },
    { threshold: 0.6 }
  );



  slides.forEach((s) => {
    io.observe(s);
    counterIO.observe(s);

    // Pre-seek only on video slides
    if (s.querySelector("video")) preSeekIO.observe(s);

  });

  // --- Luminous Made: bottom-right video play/pause indicator ---
  const videoButtons = gallery.querySelectorAll("[data-video-toggle]");

  videoButtons.forEach((btn) => {
    const video = btn.closest(".lm-video-container")?.querySelector("video");
    if (!video) return;

    const setIcon = (playing) => {
    btn.innerHTML = playing
      // solid pause icon
      ? `<svg viewBox="0 0 24 24"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>`
      // solid play icon
      : `<svg viewBox="0 0 24 24"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>`;
  };

// --- Thumbnail icon sync for videos (robust index matching) ---
const videoThumbs = document.querySelectorAll(".lm-thumb[data-type='video'], .lm-thumb[data-type='external_video']");

videoThumbs.forEach((thumb) => {
  const icon = thumb.querySelector(".lm-thumb-icon svg path");
  const thumbIndex = parseInt(thumb.dataset.thumbIndex, 10);

  // Find the slide with the same data-index
  const slide = gallery.querySelector(`.lm-slide[data-index="${thumbIndex}"]`);
  const video = slide?.querySelector("video");
  if (!video || !icon) return;

  const setThumbIcon = (playing) => {
    icon.setAttribute(
      "d",
      playing
        ? "M6 5h4v14H6zm8 0h4v14h-4z" // pause
        : "M8 5v14l11-7z"             // play
    );
  };

  // Keep the icon synced with video playback
  video.addEventListener("play", () => setThumbIcon(true));
  video.addEventListener("pause", () => setThumbIcon(false));
});


// === Desktop thumbnail video icon sync (mirror mobile) ===
const dVideoThumbs = document.querySelectorAll(".lm-d-thumb[data-type='video'], .lm-d-thumb[data-type='external_video']");

dVideoThumbs.forEach((thumb) => {
  const icon = thumb.querySelector(".lm-thumb-icon svg path");
  const thumbIndex = parseInt(thumb.dataset.dThumbIndex, 10);

  const slide = document.querySelector(`.lm-d-slide[data-d-index="${thumbIndex}"]`);
  const video = slide?.querySelector("video");
  if (!video || !icon) return;

  const setThumbIcon = (playing) => {
    icon.setAttribute(
      "d",
      playing
        ? "M6 5h4v14H6zm8 0h4v14h-4z" // pause icon
        : "M8 5v14l11-7z"             // play icon
    );
  };

  video.addEventListener("play", () => setThumbIcon(true));
  video.addEventListener("pause", () => setThumbIcon(false));
});




  // Initialize
  setIcon(!video.paused);

  // Video click (main toggle)
  video.addEventListener("click", () => {
    if (video.paused) {
      pauseOthers(video);
      video.play();
      video.dataset.userPaused = "false";
      window.lmSetPaused?.(false, 'mobile');   // ✅ share
    } else {
      video.pause();
      video.dataset.userPaused = "true";
      window.lmSetPaused?.(true, 'mobile');    // ✅ share
    }
    setIcon(!video.paused);
  });


  // Keep icon synced with programmatic play/pause
  video.addEventListener("play", () => setIcon(true));
  video.addEventListener("pause", () => setIcon(false));
});




  // --- Play overlay toggles
  slides.forEach((slide) => {
    const overlay = slide.querySelector("[data-play-overlay]");
    const video = slide.querySelector("video");
    if (!overlay || !video) return;

    const showOverlay = () => overlay.classList.remove("hidden");
    const hideOverlay = () => overlay.classList.add("hidden");

    overlay.addEventListener("click", (e) => {
      e.stopPropagation();
      video.dataset.userPaused = "false";
      pauseOthers(video);
      video.play().catch(() => {});
      hideOverlay();
      window.lmSetPaused?.(false, 'mobile');   // ✅ share play
    });

    video.addEventListener("click", () => {
      if (video.paused) {
        video.dataset.userPaused = "false";
        pauseOthers(video);
        video.play().catch(() => {});
        hideOverlay();
        window.lmSetPaused?.(false, 'mobile');   // ✅ share
      } else {
        video.dataset.userPaused = "true";
        video.pause();
        showOverlay();
        window.lmSetPaused?.(true, 'mobile');    // ✅ share
      }
    });


  });

  // --- Initialize
  updateCounter();
  updateThumbActiveState(0);
  updateArrowDisabledState();
  window.lmSetIndex?.(0, 'mobile'); // ✅ seed shared index on initial load

  const firstVideo = slides[0]?.querySelector("video");
  if (firstVideo) {
    firstVideo.dataset.userPaused = "false";
    firstVideo.play().catch(() => {});
  }


  // Allow desktop to set mobile instantly without animation
  window.__lmJumpTo = (idx) => jumpToIndex(idx);


}





// If anything previously set a bad value, sanitize on boot
if (!window.__lmGalleryState || !Number.isFinite(window.__lmGalleryState.index)) {
  window.__lmGalleryState = { index: 0, settingFrom: null };
}


// === Run gallery normally ===
document.addEventListener("DOMContentLoaded", initLmGallery);

// === Re-run on Shopify dynamic section reloads ===
document.addEventListener("shopify:section:load", initLmGallery);
document.addEventListener("shopify:section:select", initLmGallery);


// --- Timestamp handoff when switching desktop ↔ mobile (keep index unchanged) ---
(function lmWireBreakpointTimeHandoff() {
  const mq = window.matchMedia('(max-width: 749px)');
  const handoff = () => {
    const s = window.__lmGalleryState || {};
    const idx = Number.isFinite(s.index) ? s.index : 0;

    const dVideo = document.querySelector(`.lm-d-slide[data-d-index="${idx}"] video`);
    const mVideo = document.querySelector(`.lm-slide[data-index="${idx}"] video`);
    if (!dVideo || !mVideo) return;

    // choose the best source to copy from
    const src =
      (!dVideo.paused && dVideo.readyState >= 2) ? dVideo :
      (!mVideo.paused && mVideo.readyState >= 2) ? mVideo :
      (dVideo.readyState >= mVideo.readyState ? dVideo : mVideo);

    const dst = (src === dVideo) ? mVideo : dVideo;

    try { dst.currentTime = src.currentTime; } catch {}
    // honor shared paused state, but if playing, ensure both run
    if (!s.paused) { try { dst.play().catch(()=>{}); } catch {} }
  };

  // Fire on breakpoint changes and also right away once
  if (mq.addEventListener) mq.addEventListener('change', handoff);
  else if (mq.addListener) mq.addListener(handoff);
  setTimeout(handoff, 0);
})();

// === Luminous Made — Desktop Static Gallery Init ===
function initLmDesktopGallery() {
  const desktop = document.querySelector("[data-gallery-desktop]");
  if (!desktop) return;

  const stage = desktop.querySelector("[data-d-stage]");
  const slides = stage ? Array.from(stage.querySelectorAll(".lm-d-slide")) : [];
  const thumbs = Array.from(desktop.querySelectorAll("[data-d-thumb-index]"));
  if (!slides.length || !thumbs.length) return;

  // default active state
  slides.forEach((s, i) => s.classList.toggle("is-active", i === 0));

  // Desktop thumb click
  thumbs.forEach((btn) => {
    btn.addEventListener("click", () => {
      const idx = Number.parseInt(btn.dataset.dThumbIndex, 10);
      if (!Number.isFinite(idx)) return;

      const s = window.__lmGalleryState || {};
      const isDifferentSlide = idx !== s.index;

      // Hybrid C: if switching to a different slide, force play; same slide keeps current paused state
      if (isDifferentSlide) {
        window.lmSetPaused?.(false, 'desktop'); // will be honored by sync
      }

      window.lmGallerySync?.(idx, "desktop");

      // Safety: if video exists and we forced play, ensure it starts
      const slide = document.querySelector(`.lm-d-slide[data-d-index="${idx}"]`);
      const video = slide?.querySelector("video");
      if (video && isDifferentSlide) {
        try { video.currentTime = 0; } catch (_) {}
        video.dataset.userPaused = "false";
        video.play().catch(() => {});
      }
    });
  });




  // Desktop video toggles (mirror mobile behavior; respect MP1)
  (() => {
    const dStage = document.querySelector('[data-d-stage]');
    if (!dStage) return;

    const dSlides  = Array.from(dStage.querySelectorAll('.lm-d-slide'));
    const dThumbs  = Array.from(document.querySelectorAll('[data-d-thumb-index]'));
    const dButtons = Array.from(dStage.querySelectorAll('[data-d-video-toggle]'));

    const setBtnIcon = (btn, playing) => {
      if (!btn) return;
      btn.innerHTML = playing
        ? `<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>`
        : `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"></path></svg>`;
    };

    const setThumbState = (idx, playing) => {
      // Per your preference: when paused, show PLAY icon on the thumbnail (like mobile)
      const t = dThumbs.find(b => Number(b.dataset.dThumbIndex) === idx);
      if (!t) return;
      t.classList.toggle('is-playing',  !!playing);
      t.classList.toggle('is-paused',   !playing);
    };

    const pauseOthers = (keep) => {
      dSlides.forEach(slide => {
        const v = slide.querySelector('video');
        if (v && v !== keep) v.pause();
      });
    };

    const getSlideIndex = (slide) => Number(slide?.dataset.dIndex ?? slide?.dataset.index);

    // Wire up each desktop slide with a video
    dSlides.forEach(slide => {
      const vid = slide.querySelector('video');
      if (!vid) return;

      const idx = getSlideIndex(slide);
      const btn = slide.querySelector('[data-d-video-toggle]');

      // Keep icons & thumbnail state in sync with actual video state
      vid.addEventListener('play',  () => { setBtnIcon(btn, true);  setThumbState(idx, true);  });
      vid.addEventListener('pause', () => { setBtnIcon(btn, false); setThumbState(idx, false); });

      const togglePlay = () => {
        if (vid.paused) {
          vid.dataset.userPaused = 'false';
          pauseOthers(vid);
          vid.play().catch(() => {});
          window.lmSetPaused?.(false, 'desktop');   // ✅ share
        } else {
          vid.dataset.userPaused = 'true';
          vid.pause();
          window.lmSetPaused?.(true, 'desktop');    // ✅ share
        }
      };


      // Desktop: click the video itself toggles play/pause (D1)
      vid.addEventListener('click', (e) => {
        e.stopPropagation(); // don’t leak to lightbox/image handlers
        togglePlay();
      });

      // Desktop: the overlay button mirrors the same behavior
      if (btn) {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          togglePlay();
        });
      }
    });
  })();



  // Make desktop match shared index on load
  window.lmGallerySync?.(window.__lmGalleryState.index || 0, "desktop");
}

document.addEventListener("DOMContentLoaded", initLmDesktopGallery);
document.addEventListener("shopify:section:load", initLmDesktopGallery);
document.addEventListener("shopify:section:select", initLmDesktopGallery);



